import { normalize } from 'normalizr';
import fetchService from 'common/actions/fetchService';
import updateEntities from 'common/actions/updateEntities';
import providerId from 'modules/bus/shared/selectors/userConfig/busProviderId';
import busAutoCompleteStationItemSchema from 'modules/bus/booking/shared/schemas/busAutoCompleteStationItemSchema';
import { BUS_STATION_SELECTION_TYPE_ORIGIN } from '../components/BusBookingSearchForm/BusBookingSearchForm';

export const BUS_AUTO_COMPLETE_STATION_FETCH =
  'BUS/AUTO_COMPLETE_STATION_FETCH';

export const fetchAutoCompleteStation = (
  query,
  pointAutocompleteType,
  bookOnBehalfAgentId
) => {
  return (dispatch, getState) => {
    const request = {
      query,
      isDeparture: pointAutocompleteType === BUS_STATION_SELECTION_TYPE_ORIGIN,
      providerId: providerId(getState()),
      agentId: bookOnBehalfAgentId,
    };

    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetagent/search/autoComplete',
          request
        )
      )
    ).then(({ result }) => {
      const autoCompleteGroups = result.data.groups
        .filter(group => {
          return group.items && group.items.length > 0;
        })
        .map(group => {
          const { entities, result: items } = normalize(group.items, [
            busAutoCompleteStationItemSchema,
          ]);

          dispatch(updateEntities(entities));

          return {
            label: group.label,
            items,
          };
        });

      dispatch({
        type: BUS_AUTO_COMPLETE_STATION_FETCH,
        payload: autoCompleteGroups,
      });

      return autoCompleteGroups;
    });
  };
};
